import React, {useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import ModalMessage from 'common/components/ModalMessage';

function withModalMessage(WrappedComponent) {
  return props => {
    const [message, setMessage] = useState('');
    const history = useHistory();
    const location = useLocation();

    const showMessagePopup = message => {
      setMessage(message);
      history.push(`${location.pathname}/message`)
    };

    return (
      <WrappedComponent
        {...props}
        messagePopup={<ModalMessage message={message}/>}
        showMessage={showMessagePopup}
      />
    );
  };
}

export default withModalMessage;
